export default __webpack_public_path__ + "static/media/teacher.ddfdbc8e.svg";